<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5"
      >
        <el-form-item
          label="发票抬头"
          prop="title"
          :rules="[
            { required: true, message: '请输入发票抬头', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.title"></el-input>
        </el-form-item>
        <el-form-item
          label="统一社会信用代码"
          prop="credit_code"
          :rules="[
            {
              required: true,
              message: '请输入统一社会信用代码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.credit_code"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <el-form-item label="开户银行">
          <el-input v-model="state.model.opening_bank"></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="state.model.bank_account"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  customer_invoice_detail,
  customer_invoice_add,
  customer_invoice_edit,
} from "@/http/customer";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    customer_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        customer_id: props.customer_id,
      },
    });
    onMounted(() => {
      if (props.id) {
        customer_invoice_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            customer_invoice_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            customer_invoice_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
